module.exports = __webpack_public_path__ + "static/img/rankBg.48b4ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/sportRank/rankBg.png
// module id = wlHa
// module chunks = 0